export default {
    thumb(url, w, h) {
        if (!url) {
            return '';
        }
        w = w || 200;
        h = h || w || 200;
        if (url.indexOf('?') > -1) {
            return url + '&imageView2/1/w/' + w + '/h/' + h;
        } else {
            return url + '?imageView2/1/w/' + w + '/h/' + h;
        }
    },
    videoPoster(url) {
        if (url.indexOf('?') > -1) {
            return url;
        } else {
            return url + '?vframe/jpg/offset/1';
        }
    },
    join (array = [], connector) {
        return array.join(connector);
    },
    language (type) {
        var langNumber = 2; // 1 中文 2 英文 3 繁体
        var langText = 'en'; // zh 中文 en 英文 tw 繁体
        var navigatorLanguage = '';
        if (navigator.language) {
            navigatorLanguage = navigator.language.toLocaleLowerCase();
        } else {
            navigatorLanguage = navigator.browserLanguage.toLocaleLowerCase();
        }
        if (navigatorLanguage.indexOf('zh') > -1) {
            langNumber = 1;
            langText = 'zh';
        }
        if (navigatorLanguage.indexOf('zh-hk') > -1 || navigatorLanguage.indexOf('zh-tw') > -1) {
            langNumber = 3;
            langText = 'tw';
        }
        return type == 'text' ? langText : langNumber;
    },
    getHashParam: function(name) {
        var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
        var r = window.location.hash.substr(1).match(reg);
        if(r!=null)return  unescape(r[2]); return null;
    },
    getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i=0;i<vars.length;i++) {
            var pair = vars[i].split("=");
            if(pair[0] == variable){return pair[1];}
        }
        return(false);
    },
    getUrlSearch() {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        var obj = {};
        for (var i=0;i<vars.length;i++) {
            var pair = vars[i].split("=");
            obj[pair[0]] = pair[1];
        }
        return obj;
    }
}